const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
const config = {
  baseApiUrl: "https://wowtimersapi.azurewebsites.net/api/WowTimers",
  //baseApiUrl: "https://localhost:7285/api/WowTimers",
  cacheTime: ONE_DAY_IN_MS,
};

export default config;
